import { Button, CircularProgress } from '@mui/material';

const standardColors = [
  'bg-red-danger',
  'text-white',
  'hover:bg-red-danger-border',
  'disabled:text-white',
];

const invertedColors = [
  'bg-white',
  'text-typography-danger',
  'hover:bg-red-danger-bg',
  'disabled:text-typography-danger',
];

type DangerButtonProps = {
  cb: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label: string;
  disabled?: boolean;
  loading?: boolean;
  inverted?: boolean;
  type?: 'button' | 'submit' | 'reset';
};

export default function DangerButton({
  cb,
  disabled,
  loading,
  label,
  inverted,
  type = 'button',
}: DangerButtonProps) {
  const buttonClasses = [
    'px-16',
    'py-6',
    'text-14',
    'rounded-4',
    'border',
    'border-solid',
    'border-red-danger-border',
    'font-600',
    'vtwo:gap-2',
    'disabled:opacity-50',
    'transition-opacity',
    'transition-colors',
    ...(inverted ? invertedColors : standardColors),
  ].join(' ');

  function handleClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    cb(e);
  }

  return (
    <Button
      onClick={handleClick}
      disabled={loading || disabled}
      className={buttonClasses}
      type={type}
    >
      {loading && <CircularProgress size={20} color="inherit" />}
      {label}
    </Button>
  );
}
